import { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useModal } from "../../hooks/ModalContext";
import { isReadOnlyMode, LegacyResolvers } from "../../utils/UtilFunctions";
import {
  LEGACY_SCREEN_VIEW,
  ROUTE_PATHS,
  LOCAL_SCREEN_VIEW,
  SCHEDULES_DATA_KEY,
  EXTERNAL_SCHEDULES_DATA_KEY,
} from "../../utils/Constants";
import useCustomNavigate from "../Navigation/NextGenNavigation";
import { useAxios } from "../../axios/AxiosHelper";
import { URL_SCREEN_NO, EXTERNAL_PAGE_URI } from "../../utils/Constants";
import { getBaseURL } from "../../../environment/BackendService";
import { getHostnameWithPath } from "../../utils/UtilFunctions";

const useLookupNavigation = ({
  initialLookupMode,
  lookupParams,
  previousState,
  currentState,
  initialIndex,
  initialFormData,
  lookupScreen = {},
  navigateData,
  currentMode,
}) => {
  const { showModal, isModalVisible } = useModal();
  const navigateToPage = useCustomNavigate();
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  const [lookupData, setLookupData] = useState();
  const [lookupMode, setLookupMode] = useState(initialLookupMode);
  //const [currentIndex, setInitialIndex] = useState(initialIndex);

  const fetchParamData = async (
    formData,
    apiFieldInputs,
    apiFieldMapping,
    screenNumber
  ) => {
    const queryParams = apiFieldInputs.reduce((acc, item) => {
      acc[item["target"]] = formData[item["source"]];
      return acc;
    }, {});
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `${URL_SCREEN_NO[screenNumber]}`,
        null,
        queryParams
      );
      const response = raw_response.responseData;
      if (response) {
        if (response && Object.keys(response).length) {
          const mappedData = apiFieldMapping.reduce((mappedObj, mapping) => {
            mappedObj[mapping["legacy"]] = response[mapping["source"]];
            return mappedObj;
          }, {});
          console.log("Mapped Data:", mappedData);
          return mappedData;
        }
      }
    } catch (error) {}
  };

  /*useEffect(() => {
    setInitialIndex(initialIndex);
  }, [initialIndex]);*/
  const filterEmptyStringKeys = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (key !== "") {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };
  useEffect(() => {
    setLookupMode(initialLookupMode);
  }, [initialLookupMode]);
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      // console.log("dd", lookupData);
      const filteredData = filterEmptyStringKeys(data);
      setLookupData(filteredData);
    }
  };
  const resetLookupMode = () => {
    setLookupMode(false);
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(
      lookupScreen,
      { params },
      handleReceiveData,
      formData,
      false,
      handleNavigate,
      resetLookupMode,
      document.activeElement.id
    );
  };

  const viewLookupDetails = async (
    lookupScreen,
    params,
    data,
    targetScreen = null,
    parentLookupMode = false,
    navigateData = {},
    schedulesDataKey = "selectedSchedules",
    lastFocussedElementId = null
  ) => {
    const {
      viewType,
      fieldMapping,
      apiFetch,
      apiFieldMapping,
      apiFieldInputs,
      legacyProgramCode,
      appName,
      pageName,
      dataKey = "",
    } = params;
    const screenView = viewType === "conditional" ? data[dataKey] : "default";
    const { [screenView]: screenNumber } = lookupScreen;
    let { [screenView]: viewParams } = fieldMapping;
    const formData = { ...data, ...navigateData };
    let apiParamData = {};
    if (apiFetch) {
      const { default: screenNumber } = lookupScreen;
      apiParamData = await fetchParamData(
        formData,
        apiFieldInputs,
        apiFieldMapping,
        screenNumber
      );
      console.log(apiParamData, "apiParamData");
    }
    if (viewType === "legacy") {
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else if (viewType === "external") {
      const { default: viewParams } = fieldMapping;
      const formDataKey = parentLookupMode ? "target" : "source";
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["target"]])
          : formData[item[formDataKey]];
        return acc;
      }, {});
      const baseURL = getBaseURL(appName);
      const page = parentLookupMode ? targetScreen : `${pageName}_READ_ONLY`;
      const URI = EXTERNAL_PAGE_URI[page];
      const scheduleData = apiFetch ? apiParamData : paramData;
      const externalSchedulesDataKey =
        EXTERNAL_SCHEDULES_DATA_KEY[page] ?? "selectedSchedules";
      const message = {
        message: "navigate-to-external-program",
        url: baseURL + URI,
        parameters: {
          state: [
            ...previousState,
            {
              ...currentState,
              currentIndex: initialIndex,
              lookupMode: parentLookupMode,
              lookupParams: params,
              lookupScreen: lookupScreen,
              navigateData,
              formData: data,
              ...(lastFocussedElementId ? { lastFocussedElementId } : {}),
            },
            {
              [externalSchedulesDataKey]: [scheduleData],
              currentIndex: 0,
              previousScreen: getHostnameWithPath(window.location.href),
            },
          ],
        },
      };
      console.log("message", message);
      window.parent.postMessage(message, "*");
    } else {
      //showModal(lookupScreen, { params }, null, formData, true);
      // const { default: screenNumber } = lookupScreen;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["target"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      console.log("param data", paramData);
      const navigationPath = ROUTE_PATHS[LOCAL_SCREEN_VIEW[screenNumber]];
      navigateToPage(navigationPath, [
        ...previousState,
        {
          ...currentState,
          currentIndex: initialIndex,
          formData: formData,
          currentMode,
        },
        {
          [SCHEDULES_DATA_KEY[screenNumber]]: [paramData],
          currentIndex: 0,
          paramsData: { ...paramData, cscStepNbr: null },
          previousScreen: location.pathname,
        },
      ]);
    }
  };

  /*const viewLookupDetailsCopy = async (
    lookupScreen,
    params,
    data,
    targetScreen = null,
    parentLookupMode = false,
    navigateData = {}
  ) => {
    const {
      viewType,
      fieldMapping,
      apiFetch,
      apiFieldMapping,
      apiFieldInputs,
      legacyProgramCode,
      appName,
      pageName,
    } = params;
    const formData = { ...data, ...navigateData };
    const { default: screenNumber } = lookupScreen;
    let apiParamData = {};
    if (apiFetch) {
      const { default: screenNumber } = lookupScreen;
      apiParamData = await fetchParamData(
        formData,
        apiFieldInputs,
        apiFieldMapping,
        screenNumber
      );
      console.log(apiParamData, "apiParamData");
    }
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: legacyProgramCode
          ? legacyProgramCode
          : LEGACY_SCREEN_VIEW[screenNumber],
        parameters: apiFetch ? apiParamData : paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else if (viewType === "external") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        const resolver = item["resolver"]
          ? LegacyResolvers[item["resolver"]]
          : null;
        acc[item["legacy"]] = resolver
          ? resolver(formData[item["source"]])
          : formData[item["source"]];
        return acc;
      }, {});
      const baseURL = getBaseURL(appName);
      const page = parentLookupMode ? targetScreen : `${pageName}_READ_ONLY`;
      const URI = EXTERNAL_PAGE_URI[page];
      const scheduleData = apiFetch ? apiParamData : paramData;
      const message = {
        message: "navigate-to-external-program",
        url: baseURL + URI,
        parameters: {
          state: [
            ...previousState,
            {
              ...currentState,
              currentIndex,
              lookupMode: parentLookupMode,
              lookupParams: params,
              lookupScreen: lookupScreen,
              navigateData,
              formData: data,
            },
            {
              selectedSchedules: [scheduleData],
              currentIndex: 0,
              previousScreen: getHostnameWithPath(window.location.href),
            },
          ],
        },
      };
      console.log("message", message);
      window.parent.postMessage(message, "*");
    } else {
      showModal(
        lookupScreen,
        { params },
        null,
        formData,
        true,
        handleNavigate,
        resetLookupMode
      );
    }
  };*/

  const handleNavigate = (
    data,
    screenNumber,
    params,
    formData,
    lastFocussedElementId = null
  ) => {
    console.log("handle Navigate", data);
    if (data?.navType === "local") {
      const schedulesDataKey = data?.schedulesDataKey ?? "selectedPatients";
      const additionalData = data?.additionalData ?? {};
      const dataDrafted =
        JSON.stringify(initialFormData) !== JSON.stringify(formData);
      navigateToPage(data.target, [
        ...previousState,
        {
          ...currentState,
          currentIndex: initialIndex,
          lookupMode: true,
          lookupScreen: screenNumber,
          lookupParams: params,
          navigateData: data.data,
          formData: formData,
          currentMode: currentMode,
          dataDrafted: dataDrafted,
        },
        {
          [schedulesDataKey]: [data.data],
          previousScreen: location.pathname,
          currentIndex: 0,
          ...additionalData,
        },
      ]);
    } else {
      if (data && Object.keys(data).length) {
        viewLookupDetails(
          lookupScreen,
          params,
          formData,
          data.target,
          true,
          data.data,
          data.schedulesDataKey,
          lastFocussedElementId
        );
      }
    }
  };

  useEffect(() => {
    if (!isModalVisible && currentState?.lastFocussedElementId) {
      const timeout = setTimeout(() => {
        document
          .querySelector(`#${currentState?.lastFocussedElementId}`)
          ?.focus();

        currentState.lastFocussedElementId = null;
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [isModalVisible]);

  useEffect(() => {
    if (
      lookupMode &&
      initialFormData &&
      Object.keys(initialFormData).length &&
      !isReadOnlyMode(currentMode)
    ) {
      //console.log("lookup auto init", initialFormData, navigateData);
      //const lookupParamsData =
      console.log("navigate data", lookupParams, navigateData);
      //navigateData;
      const { viewType, dataKey } = lookupParams;
      const screenView =
        viewType === "conditional" ? initialFormData[dataKey] : "default";
      const params = lookupParams.fieldMapping[screenView];
      const paramData = params?.reduce((acc, key) => {
        if (
          key["navigateDataKey"] &&
          navigateData.hasOwnProperty(key["navigateDataKey"])
        ) {
          acc[key["source"]] = navigateData[key["navigateDataKey"]];
        } else if (navigateData.hasOwnProperty(key["target"])) {
          acc[key["source"]] = navigateData[key["target"]];
        }
        return acc;
      }, {});
      showModal(
        lookupScreen,
        { params: lookupParams },
        handleReceiveData,
        { ...initialFormData, ...paramData },
        null,
        handleNavigate,
        resetLookupMode
      );
    }
  }, [initialFormData, lookupMode, lookupParams, lookupScreen]);
  return {
    fetchLookupData,
    viewLookupDetails,
    lookupData,
    lookupMode,
    setLookupMode,
  };
};
export default useLookupNavigation;
